import React from 'react';

const DemoArchetypeSpotlightCard = ({ archetype }) => {
    return (
        <div className="rounded-[2rem] border-2 border-[var(--color-highlight)]/60 bg-gradient-to-br from-white via-[#fffaf7] to-[#f8f4ff] p-6 md:p-8 shadow-[0_12px_40px_rgba(243,119,65,0.15)] h-full relative overflow-hidden">
            <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-white/75 to-transparent pointer-events-none"></div>
            <span className="relative z-10 inline-flex rounded-full bg-gradient-to-r from-[var(--color-highlight)] to-[var(--color-brand)] text-white text-xs md:text-sm px-4 py-1.5 font-bold shadow-md">
                {archetype.banner}
            </span>

            <div className="relative z-10 mt-6 grid gap-5 md:grid-cols-[120px_1fr] md:gap-6 items-start">
                <div className="w-[110px] h-[110px] rounded-[1.75rem] bg-white shadow-lg border border-orange-100 flex items-center justify-center text-5xl">
                    💡
                </div>

                <div>
                    <p className="text-sm uppercase tracking-[0.2em] text-gray-500 font-bold">Core Identity</p>
                    <h3 className="text-3xl md:text-4xl font-black text-[#171717] brand-font mt-2">{archetype.name}</h3>
                    <p className="mt-3 text-lg text-[#171717] font-semibold brand-text">{archetype.identity}</p>

                    <div className="mt-5">
                        <p className="text-sm uppercase tracking-[0.16em] text-[var(--color-brand)] font-bold">{archetype.strengthTitle}</p>
                        <p className="mt-2 text-base text-gray-700 leading-relaxed brand-text">{archetype.strengthText}</p>
                    </div>
                </div>
            </div>

            <div className="relative z-10 mt-6 rounded-2xl bg-white border border-[var(--color-highlight)]/15 p-4 md:p-5 shadow-sm">
                <p className="text-base md:text-lg font-semibold text-[#171717] leading-relaxed brand-text">{archetype.formula}</p>
            </div>

            <ul className="relative z-10 mt-6 space-y-3">
                {archetype.bullets.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-gray-700 brand-text">
                        <span className="mt-1 inline-flex w-6 h-6 rounded-full bg-[var(--color-brand)]/10 text-[var(--color-brand)] items-center justify-center font-black">•</span>
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DemoArchetypeSpotlightCard;
